__webpack_require__.p = "/calculating-inflation/";